import { SegmentedPeriodSelector } from "../../_lib/segmented-period-selector";
import {
  PROGRAM_PERIOD_OPTIONS,
  type ProgramPeriodKey,
} from "./program-period";

export const ProgramPeriodSelector: FC<{
  period: ProgramPeriodKey;
  onChange: (period: ProgramPeriodKey) => void;
}> = ({ period, onChange }) => (
  <SegmentedPeriodSelector
    options={PROGRAM_PERIOD_OPTIONS}
    value={period}
    onChange={onChange}
    label="Reporting period"
  />
);
